<template>
  <div class="interOperTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('cooperation.buttons.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('cooperation.buttons.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="interOperTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'interOperTable',
    components: {},
    data() {
      return {
        tableData: [],
        delList: [],
      };
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'eventCode',
            title: this.$t('businessType.interOperTable.eventCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'eventName',
            title: this.$t('businessType.interOperTable.eventName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'conditionRule',
            title: this.$t('businessType.interOperTable.conditionRule'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'eventDesc',
            title: this.$t('businessType.interOperTable.eventDesc'),
            editRender: {
              name: 'ElInput',
              default: '',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {
          eventCode: [
            {
              required: true,
              message: this.$t('businessType.interOperTable.eventCodePlaceholder'),
            },
          ],
          eventName: [
            {
              required: true,
              message: this.$t('businessType.interOperTable.eventNamePlaceholder'),
            },
          ],
          conditionRule: [
            {
              required: true,
              message: this.$t('businessType.interOperTable.conditionRulePlaceholder'),
            },
          ],
        };
      },
    },
    mounted() {},
    methods: {
      async getData(orderCode) {
        if (orderCode) {
          this.loading = true;
          let res = await this.$axios.post(API.QUERY_INTERESTEVENTTYPE, { orderCode });
          if (res) {
            this.loading = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data;
            }
          }
        } else {
          this.tableData = [];
        }
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.interOperTable.validate((valid) => {
          if (valid) {
            let record = {
              eventCode: null,
              eventName: null,
              conditionRule: null,
              eventDesc: null,
            };
            this.$refs.interOperTable.insertAt(record, row).then(({ row }) => {
              this.$refs.interOperTable.setActiveRow(row);
            });
          }
        });
      },
      handleDelete() {
        const selectedList = this.$refs.interOperTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('businessType.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.delList.push(item.id);
              }
            });
            this.$refs.interOperTable.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('businessType.msg.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('businessType.msg.cancelled'),
            });
          });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.interOperTable.getTableData().fullData;
        // 点击提交，走校验
        return new Promise((resolve) => {
          this.$refs.interOperTable.validate((valid) => {
            if (valid) {
              let param = {
                eventList: tableData,
                delList: this.delList,
              };
              resolve(param);
            }
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
